var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boxx"},[_c('h6',[_vm._v("Use Guide")]),_c('div',{staticClass:"red-box"},[_c('ul',_vm._l((_vm.instructions),function(instr,i){return _c('li',{key:i},[_c('div',{staticClass:"dark-red-box"},[_vm._v(_vm._s(i))]),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(instr)}})])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }